import React, { Component, Fragment } from 'react';
import { Checkbox, Form } from 'semantic-ui-react';
import ReactTable from 'react-table';
import connect from 'react-redux/es/connect/connect';
import { formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { AssignEntitiesEnum, SiteEnum, SiteGroupEnum } from 'Common/FieldEnum';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import EditableLabel from 'Components/editableLabel/EditableLabel';
import {
  ReactTableWrapperColumnProperties,
  UNSAVED_MESSAGE,
} from 'Common/Constants';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import {
  ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME,
  ASSIGN_ENTITIES_FORM_NAME,
} from 'Common/FormEnum';

import {
  getCheckedData,
  checkVisibilityForSiteGroupUser,
  getCheckedGridData,
  getCheckedRefData,
  getFilteredIds,
  GridResetInitialValueEnum,
  GridNames,
} from '../../../helper/assignEntities';
import {
  getItemsBySiteGroupId,
  getSiteGroupData,
  getUsersBySiteGroupId,
} from '../../../state/assignEntities/actions';
import * as Selectors from '../../../state/assignEntities/selectors';

class SiteGroupGrid extends Component {
  static propTypes = {
    dataSource: PropTypes.array.isRequired,
    siteGroupData: PropTypes.array.isRequired,
    allItemsData: PropTypes.array.isRequired,
    usersBySiteGroupId: PropTypes.array.isRequired,
    siteGroupsByUserName: PropTypes.array.isRequired,
    resetGridPage: PropTypes.object.isRequired,
    setIsReadOnlyState: PropTypes.func,
    onResetPageOnDataChange: PropTypes.func,
    onLeftGridFilteredChange: PropTypes.func,
    onFilteredChange: PropTypes.func,
    getItemsBySiteGroupId: PropTypes.func.isRequired,
    getSiteGroupData: PropTypes.func.isRequired,
    getUsersBySiteGroupId: PropTypes.func.isRequired,
    siteGroupGridInfo: PropTypes.array,
    itemsBySiteGroupId: PropTypes.array.isRequired,
    siteGroupsByItemId: PropTypes.array.isRequired,
    leftSideGridReactTableRef: PropTypes.object,
    rightSideGridReactTableRef: PropTypes.object,
    isReadOnly: PropTypes.bool,
    direction: PropTypes.bool,
    isLeftGridFiltered: PropTypes.bool,
    isStorageLocationPage: PropTypes.bool,
    isRightGridFiltered: PropTypes.bool,
    isLeftSideItemGrid: PropTypes.bool,
    isRightSideSiteGroupGrid: PropTypes.bool,
    isLeftSideSiteGroupGrid: PropTypes.bool,
    isRightSideItemGrid: PropTypes.bool,
    isRightSideUserGrid: PropTypes.bool,
    isLeftSideUserGrid: PropTypes.bool,
    loadingSiteGroup: PropTypes.bool.isRequired,
    loadingAllSites: PropTypes.bool.isRequired,
    loadingStorageLocationById: PropTypes.bool,
  };

  static defaultProps = {
    direction: true,
    isReadOnly: true,
    isLeftGridFiltered: false,
    isStorageLocationPage: false,
    isRightGridFiltered: false,
    isLeftSideItemGrid: false,
    isRightSideSiteGroupGrid: false,
    isLeftSideSiteGroupGrid: false,
    isRightSideItemGrid: false,
    isRightSideUserGrid: false,
    isLeftSideUserGrid: false,
    leftSideGridReactTableRef: null,
    rightSideGridReactTableRef: null,
    onLeftGridFilteredChange: () => {},
    onFilteredChange: () => {},
    onResetPageOnDataChange: () => {},
    setIsReadOnlyState: () => {},
    siteGroupGridInfo: [],
    loadingStorageLocationById: false,
  };

  state = {
    page: 0,
    selected: 0,
    expanded:
      this.props.isLeftSideSiteGroupGrid && !this.props.isLeftSideUserGrid
        ? {
            0: true,
          }
        : {},
    showUnsavedModal: false,
    rowInfo: null,
    current: null,
    callSetExpandedGroup: false,
  };

  columns = [
    {
      Header: () => {
        const {
          input: { value },
          dataSource,
          isStorageLocationPage,
          isLeftSideUserGrid,
          rightSideGridReactTableRef,
          siteGroupGridInfo,
          leftSideGridReactTableRef,
        } = this.props;
        let check = false;
        if (
          value &&
          value.length &&
          dataSource.length > 0 &&
          (isStorageLocationPage || isLeftSideUserGrid)
        ) {
          if (
            (isLeftSideUserGrid &&
              rightSideGridReactTableRef &&
              rightSideGridReactTableRef.current) ||
            (isStorageLocationPage &&
              leftSideGridReactTableRef &&
              leftSideGridReactTableRef.current)
          ) {
            const sortedData = isLeftSideUserGrid
              ? rightSideGridReactTableRef.current.getResolvedState().sortedData
              : leftSideGridReactTableRef.current.getResolvedState().sortedData;
            check =
              sortedData.length > 0 &&
              sortedData.length ===
                getCheckedGridData(
                  sortedData,
                  siteGroupGridInfo,
                  SiteGroupEnum.Id
                ).length;
          } else {
            check = dataSource.length === value.length;
          }
        } else if (
          rightSideGridReactTableRef &&
          rightSideGridReactTableRef.current
        ) {
          const sortedData = rightSideGridReactTableRef.current.getResolvedState()
            .sortedData;
          const checkedData = getCheckedData(
            getCheckedRefData(sortedData, SiteGroupEnum.CheckBox),
            SiteGroupEnum.CheckBox
          );
          check =
            sortedData.length > 0 && sortedData.length === checkedData.length;
        }

        return (
          <Checkbox
            checked={check}
            onClick={(e, data) => {
              isStorageLocationPage || isLeftSideUserGrid
                ? this.handleHeaderLevelCheckBoxWithStorageLocation(
                    data.checked
                  )
                : this.handleHeaderLevelCheckbox(data.checked);
            }}
          />
        );
      },
      Cell: rowInfo => {
        const {
          input: { value },
          isStorageLocationPage,
          isLeftSideUserGrid,
        } = this.props;

        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={
                value &&
                (isStorageLocationPage || isLeftSideUserGrid
                  ? value.indexOf(rowInfo.original[SiteGroupEnum.Id]) !== -1
                  : Boolean(rowInfo.original.CheckBox))
              }
              onClick={(e, data) => {
                isStorageLocationPage || isLeftSideUserGrid
                  ? this.handleChangeCheckboxWithStorageLocation(
                      rowInfo.original,
                      data.checked
                    )
                  : this.handleChangeCheckbox(rowInfo.original, data.checked);
              }}
            />
          </div>
        );
      },
      maxWidth: 74,
      sortable: false,
      filterable: false,
      show:
        this.props.isRightSideSiteGroupGrid || this.props.isStorageLocationPage,
    },
    {
      columns: [
        {
          Header: 'Id',
          accessor: SiteGroupEnum.Id,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Description',
          accessor: SiteGroupEnum.Description,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Min. Par',
          show: checkVisibilityForSiteGroupUser(this.props),
          sortable: false,
        },
        {
          Header: 'Max. Par',
          show: checkVisibilityForSiteGroupUser(this.props),
          sortable: false,
        },
      ],
    },
  ];

  handleChangeMinPar = (refData, newValue) => {
    this.handleParLevelChange(refData, newValue, SiteGroupEnum.MinimumParLevel);
  };

  handleChangeMaxPar = (refData, newValue) => {
    this.handleParLevelChange(refData, newValue, SiteGroupEnum.MaximumParLevel);
  };

  handleParLevelChange = (refData, newValue, fieldName) => {
    newValue = newValue.match(/\d{0,6}(\.\d{0,3})?/)[0];
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    const index = _.findIndex(formValues, formValue => {
      return formValue[SiteGroupEnum.Id] === refData[SiteGroupEnum.Id];
    });
    if (index > -1) {
      formValues[index][fieldName] = newValue;
    } else {
      const newFiled = Object.assign({}, refData);
      newFiled[fieldName] = newValue;
      formValues.push(newFiled);
    }
    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(formValues);
  };

  prepareTableData = () => {
    const dataSourceCopy =
      this.props.dataSource && this.props.dataSource.length
        ? _.cloneDeep(this.props.dataSource)
        : [];
    const { value } = this.props.input;
    if (value && value.length && dataSourceCopy && dataSourceCopy.length) {
      _.each(value, item => {
        const index = _.findIndex(dataSourceCopy, {
          [SiteGroupEnum.Id]: item[SiteGroupEnum.Id],
        });
        if (index > -1) {
          const dataRow = { ...item };
          dataSourceCopy[index][SiteGroupEnum.MinimumParLevel] =
            dataRow[SiteGroupEnum.MinimumParLevel];
          dataSourceCopy[index][SiteGroupEnum.MaximumParLevel] =
            dataRow[SiteGroupEnum.MaximumParLevel];
          dataSourceCopy[index][SiteGroupEnum.CheckBox] =
            dataRow[SiteGroupEnum.CheckBox];
          dataSourceCopy[index][SiteGroupEnum.SiteModel] =
            dataRow[SiteGroupEnum.SiteModel];
        }
      });
    } else {
      dataSourceCopy.forEach(siteGrp => {
        siteGrp[SiteGroupEnum.MinimumParLevel] = null;
        siteGrp[SiteGroupEnum.MaximumParLevel] = null;
      });
    }
    return dataSourceCopy;
  };

  handleUnsavedModal(result) {
    if (result) {
      this.props.setIsReadOnlyState(true);
      this.state.rowInfo &&
        this.props.input.onChange([this.state.rowInfo.original.Id]);
      this.setExpandedGroup();
      this.setState({
        showUnsavedModal: false,
      });
    } else {
      const { expanded, current } = this.state;
      const expandedCopy = Object.assign({}, expanded);
      expandedCopy[current] = false;
      this.state.prevSiteGroupId &&
        this.props.input.onChange([this.state.prevSiteGroupId]);
      this.setState({
        showUnsavedModal: false,
        expanded: expandedCopy,
        callSetExpandedGroup: false,
      });
    }
  }
  getTrProps = (state, rowInfo) => {
    const {
      isRightSideSiteGroupGrid,
      isLeftSideSiteGroupGrid,
      isStorageLocationPage,
    } = this.props;
    let styleObj = {};
    if (
      isLeftSideSiteGroupGrid &&
      rowInfo &&
      !isStorageLocationPage &&
      rowInfo.original &&
      this.props.input.value.indexOf(rowInfo.original[SiteGroupEnum.Id]) !== -1
    ) {
      styleObj = {
        color: '#df5a17',
        fontWeight: '600',
      };
    }
    return {
      onClick: e => {
        if (!isStorageLocationPage) {
          if (rowInfo && rowInfo.original) {
            if (
              isLeftSideSiteGroupGrid &&
              this.props.input.value.indexOf(
                rowInfo.original[SiteGroupEnum.Id]
              ) === -1
            ) {
              const showUnsavedModal = !this.props.isReadOnly;
              this.setState({
                showUnsavedModal: showUnsavedModal,
                rowInfo,
                prevSiteGroupId: this.props.input.value[0],
                callSetExpandedGroup: true,
              });
            }
          } else if (isRightSideSiteGroupGrid) {
            let copy = _.cloneDeep(this.state.expanded);
            if (this.state.current) {
              copy[this.state.current] = false;
            } else {
              copy = {
                0: !copy[0],
              };
            }
            this.setState({
              expanded: copy,
            });
          }
        }
      },
      style: styleObj,
    };
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.loadingSiteGroup !== this.props.loadingSiteGroup &&
      this.props.isRightSideSiteGroupGrid
    ) {
      this.setState({
        expanded: {},
      });
    }
    if (
      this.props.isRightSideSiteGroupGrid &&
      (this.props.isLeftSideItemGrid || this.props.isLeftSideUserGrid) &&
      ((prevProps.loadingAllSites !== this.props.loadingAllSites &&
        this.props.loadingAllSites) ||
        (prevProps.loadingSiteGroup !== this.props.loadingSiteGroup &&
          this.props.loadingSiteGroup))
    ) {
      this.setState({ page: 0 });
    }
  }

  componentDidMount() {
    const {
      getSiteGroupData,
      isLeftSideSiteGroupGrid,
      isRightSideUserGrid,
      getUsersBySiteGroupId,
      isRightSideItemGrid,
      getItemsBySiteGroupId,
      isStorageLocationPage,
    } = this.props;

    !isStorageLocationPage &&
      getSiteGroupData().then(() => {
        const { siteGroupData } = this.props;
        if (siteGroupData && siteGroupData.length && isLeftSideSiteGroupGrid) {
          !isStorageLocationPage &&
            isRightSideUserGrid &&
            getUsersBySiteGroupId(siteGroupData[0].Id);
          !isStorageLocationPage &&
            isRightSideItemGrid &&
            getItemsBySiteGroupId(siteGroupData[0].Id);
          this.props.input.onChange([siteGroupData[0].Id]);
          this.props.onResetPageOnDataChange({
            ...GridResetInitialValueEnum,
            [GridNames.SiteGroup]: false,
          });
        }
      });
  }

  handleHeaderLevelCheckBoxWithStorageLocation = checked => {
    const {
      isRightGridFiltered,
      rightSideGridReactTableRef,
      dataSource,
      siteGroupGridInfo,
      isLeftGridFiltered,
      isStorageLocationPage,
      isLeftSideUserGrid,
      leftSideGridReactTableRef,
    } = this.props;
    if (
      (isLeftSideUserGrid &&
        isRightGridFiltered &&
        rightSideGridReactTableRef &&
        rightSideGridReactTableRef.current) ||
      (isLeftGridFiltered &&
        isStorageLocationPage &&
        leftSideGridReactTableRef &&
        leftSideGridReactTableRef.current)
    ) {
      const sortedData = isLeftSideUserGrid
        ? rightSideGridReactTableRef.current.getResolvedState().sortedData
        : leftSideGridReactTableRef.current.getResolvedState().sortedData;
      const sortedSiteGroupsData = getFilteredIds(sortedData, SiteGroupEnum.Id);
      let siteGroupGridInfoCopy = [...siteGroupGridInfo];
      let siteGroupsToChange;
      if (checked) {
        siteGroupsToChange = _.union(
          sortedSiteGroupsData,
          siteGroupGridInfoCopy
        );
      } else {
        _.remove(siteGroupGridInfoCopy, siteId => {
          return sortedSiteGroupsData.includes(siteId);
        });
        siteGroupsToChange = siteGroupGridInfoCopy;
      }
      this.props.input.onChange(siteGroupsToChange);
    } else {
      const siteGroups = checked
        ? _.map(dataSource, siteGroup => {
            return siteGroup[SiteGroupEnum.Id];
          })
        : [];
      this.props.input.onChange(siteGroups);
    }
    this.props.setIsReadOnlyState(false);
  };

  handleHeaderLevelCheckbox = checked => {
    const {
      dataSource,
      input: { value },
      rightSideGridReactTableRef,
    } = this.props;
    let dataSourceCopy =
      dataSource && dataSource.length ? _.cloneDeep(dataSource) : [];
    if (value && value.length && dataSourceCopy && dataSourceCopy.length) {
      _.each(value, formValue => {
        const index = _.findIndex(dataSourceCopy, {
          [SiteGroupEnum.Id]: formValue[SiteGroupEnum.Id],
        });
        if (index > -1) {
          dataSourceCopy[index] = { ...formValue };
        }
      });
    }
    if (rightSideGridReactTableRef && rightSideGridReactTableRef.current) {
      const filteredData = rightSideGridReactTableRef.current.getResolvedState()
        .sortedData;
      _.each(filteredData, filterItem => {
        const index = _.findIndex(dataSourceCopy, {
          [SiteGroupEnum.Id]: filterItem._original[SiteGroupEnum.Id],
        });
        if (index > -1) {
          dataSourceCopy[index] = filterItem._original;
          dataSourceCopy[index][SiteGroupEnum.CheckBox] = checked;
        }
      });
    } else if (dataSourceCopy && dataSourceCopy.length) {
      dataSourceCopy = dataSourceCopy.map(siteGrp => {
        siteGrp[SiteGroupEnum.CheckBox] = checked;
        return siteGrp;
      });
    }
    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(dataSourceCopy);
  };

  componentWillUnmount() {
    this.props.input.onChange([]);
  }
  handleChangeCheckboxWithStorageLocation = (original, checked) => {
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    let index = formValues.indexOf(original[SiteGroupEnum.Id]);
    if (checked) {
      index === -1 && formValues.push(original[SiteGroupEnum.Id]);
    } else {
      if (index !== -1) {
        formValues.splice(index, 1);
      }
    }
    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(formValues);
  };
  handleChangeCheckbox = (original, Checked) => {
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    const index = formValues.findIndex(formValue => {
      return original[SiteGroupEnum.Id] === formValue[SiteGroupEnum.Id];
    });
    if (index > -1) {
      formValues[index][SiteGroupEnum.CheckBox] = Checked;
    } else {
      formValues.push({
        ...original,
        [SiteGroupEnum.CheckBox]: Checked,
      });
    }
    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(formValues);
  };

  setExpandedGroup = storageObj => {
    let callApi = false;
    const {
      isLeftSideSiteGroupGrid,
      isRightSideItemGrid,
      isRightSideUserGrid,
      isStorageLocationPage,
    } = this.props;
    const { expanded, current } = storageObj ? storageObj : this.state;
    if (expanded && current && current.length) {
      callApi = expanded[current[0]]
        ? expanded[current[0]]
        : !expanded[current[0]];
    }
    if (
      !isStorageLocationPage ||
      (this.state.rowInfo &&
        this.state.rowInfo.original &&
        this.props.input.value.indexOf(
          this.state.rowInfo.original[SiteGroupEnum.Id]
        ) === -1)
    ) {
      if (
        isLeftSideSiteGroupGrid &&
        isRightSideItemGrid &&
        this.props.input.value &&
        callApi
      ) {
        this.props.getItemsBySiteGroupId(this.state.rowInfo.original.Id);
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.SiteGroup]: false,
        });
      }
      if (
        isLeftSideSiteGroupGrid &&
        isRightSideUserGrid &&
        this.props.input.value &&
        callApi
      ) {
        this.props.getUsersBySiteGroupId(this.state.rowInfo.original.Id);
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.SiteGroup]: false,
        });
      }
    }

    let expandedCopy = {
      0: true,
    };
    const { rowInfo } = this.state;
    if (expanded && current && current.length) {
      if (rowInfo && rowInfo.original) {
        this.props.input.onChange([rowInfo.original[SiteGroupEnum.Id]]);
      }
      _.forEach(expanded, (value, key) => {
        expandedCopy[key] = +key === current[0];
      });
    }
    this.setState({
      expanded: expandedCopy,
      callSetExpandedGroup: false,
    });
  };
  render() {
    const {
      loadingSiteGroup,
      siteGroupData,
      loadingAllSites,
      loadingStorageLocationById,
      onFilteredChange,
      rightSideGridReactTableRef,
      leftSideGridReactTableRef,
      onLeftGridFilteredChange,
      isStorageLocationPage,
    } = this.props;
    return (
      <Fragment>
        <Form.Field>
          <ReactTable
            loading={
              loadingSiteGroup || loadingAllSites || loadingStorageLocationById
            }
            ref={
              isStorageLocationPage
                ? leftSideGridReactTableRef
                : rightSideGridReactTableRef
            }
            NoDataText={loadingSiteGroup ? '' : 'No site groups found'}
            loadingText={loadingSiteGroup ? 'Loading...' : ''}
            expanded={this.state.expanded}
            onExpandedChange={(expanded, current) => {
              if (!this.props.isStorageLocationPage) {
                this.setState({
                  expanded,
                  current,
                });
                this.state.callSetExpandedGroup &&
                  !this.state.showUnsavedModal &&
                  this.setExpandedGroup({
                    expanded,
                    current,
                  });
              } else if (this.props.isStorageLocationPage) {
                this.setExpandedGroup({
                  expanded,
                  current,
                });
              }
            }}
            page={this.state.page}
            onPageChange={currentPge => {
              this.setState({
                page: currentPge,
              });
            }}
            onPageSizeChange={(currentPageSize, currentPage) => {
              this.setState({
                page: currentPage,
              });
            }}
            collapseOnPageChange={true}
            data={
              this.props.isRightSideSiteGroupGrid &&
              !this.props.isLeftSideUserGrid
                ? this.prepareTableData()
                : siteGroupData
                  ? siteGroupData
                  : []
            }
            getTrProps={this.getTrProps}
            columns={this.columns}
            defaultPageSize={5}
            onFilteredChange={
              isStorageLocationPage
                ? onLeftGridFilteredChange
                : onFilteredChange
            }
            defaultFilterMethod={caseInsensitiveFilter}
            SubComponent={rowData => {
              const row = rowData.original;
              const columns = [
                {
                  Header: 'Description',
                  accessor: SiteEnum.Description,
                  sortable: false,
                },
                {
                  Header: () => {
                    return (
                      <div>
                        Order
                        <br />
                        Preference
                      </div>
                    );
                  },
                  accessor: SiteEnum.OrderPreferenceName,
                  sortable: false,
                },
                {
                  accessor: SiteEnum.MinimumParLevel,
                  show: checkVisibilityForSiteGroupUser(this.props),
                  Header: () => {
                    return (
                      <Fragment>
                        <div>Min. Par</div>
                        <EditableLabel
                          label={
                            String(row[SiteGroupEnum.MinimumParLevel])
                              ? row[SiteGroupEnum.MinimumParLevel]
                              : ''
                          }
                          labelClassName={'qtyLabel'}
                          refData={row}
                          inputType={'text'}
                          onChange={this.handleChangeMinPar}
                          allowEdit={true}
                          className={' ht-26 mt--5'}
                          disabled={!row[SiteGroupEnum.CheckBox]}
                        />
                      </Fragment>
                    );
                  },
                  sortable: false,
                },
                {
                  accessor: SiteEnum.MaximumParLevel,
                  show: checkVisibilityForSiteGroupUser(this.props),
                  Header: () => {
                    return (
                      <Fragment>
                        <div>Max. Par</div>
                        <EditableLabel
                          label={
                            String(row[SiteGroupEnum.MaximumParLevel])
                              ? row[SiteGroupEnum.MaximumParLevel]
                              : ''
                          }
                          labelClassName={'qtyLabel'}
                          refData={row}
                          inputType={'text'}
                          onChange={this.handleChangeMaxPar}
                          allowEdit={true}
                          className={' ht-26 mt--5'}
                          disabled={!row[SiteGroupEnum.CheckBox]}
                        />
                      </Fragment>
                    );
                  },
                  sortable: false,
                },
              ];
              return (
                <div style={{ padding: '0px 10px 10px 15px' }}>
                  <ReactTable
                    data={row[SiteGroupEnum.SiteModel]}
                    columns={columns}
                    pageSize={row[SiteGroupEnum.SiteModel].length}
                    showPagination={false}
                  />
                </div>
              );
            }}
          />
          <YesNoDialog
            showDialog={this.state.showUnsavedModal}
            title="Un-saved changes detected"
            question={UNSAVED_MESSAGE}
            yesCallback={() => {
              this.handleUnsavedModal(true);
            }}
            noCallback={() => {
              this.handleUnsavedModal(false);
            }}
          />
        </Form.Field>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const selector = ownProps.isStorageLocationPage
    ? formValueSelector(ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME)
    : formValueSelector(ASSIGN_ENTITIES_FORM_NAME);

  return {
    siteGroupGridInfo: selector(state, AssignEntitiesEnum.SiteGroupGridInfo),
    siteGroupData: Selectors.getSiteGroupData(state),
    loadingSiteGroup: Selectors.getLoadingSiteGroup(state),
    itemsBySiteGroupId: Selectors.getItemsBySiteGroupId(state),
    siteGroupsByItemId: Selectors.getSiteGroupsByItemId(state),
    allItemsData: Selectors.getAllItemsData(state),
    usersBySiteGroupId: Selectors.getUsersBySiteGroupId(state),
    loadingAllSites: Selectors.getLoadingAllSites(state),
    loadingStorageLocationById: Selectors.getLoadingStorageLocationById(state),
    siteGroupsByUserName: Selectors.getSiteGroupsByUserName(state),
  };
};

const mapDispatchToProps = {
  getItemsBySiteGroupId,
  getSiteGroupData,
  getUsersBySiteGroupId,
};

export const SiteGroupGridContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SiteGroupGrid);



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/containers/assignEntities/SiteGroupGridContainer.js